// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 7.5C6 4.46243 8.46243 2 11.5 2C14.5376 2 17 4.46243 17 7.5C17 10.5376 14.5376 13 11.5 13C8.46243 13 6 10.5376 6 7.5ZM14.5 13.5H23.5V19.1336C23.5 20.1466 22.9888 21.0912 22.1407 21.6452L19 23.6969L15.8593 21.6452C15.0112 21.0912 14.5 20.1466 14.5 19.1336V13.5ZM12.5 22H2V20C2 16.6863 4.68629 14 8 14H12.5V22Z"}}]};

const UserSafetyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-safety-filled',
    ref,
    icon: element,
  },
));

UserSafetyFilledIcon.displayName = 'UserSafetyFilledIcon';

export default UserSafetyFilledIcon;
